import {
  useState,
  useEffect,
  useCallback,
  useRef
} from 'react'
import { withScreenInfo } from '@/components/withScreenInfo'

interface ScreenInfo {
  shouldDisplay: {
    inputMask?: boolean
  }
}

interface InputMaskProps {
  screen: ScreenInfo
}

const InputMask = ({ screen }: InputMaskProps) => {
  const [value, setValue] = useState('')
  const interval = useRef<ReturnType<typeof setInterval> | undefined>(undefined)

  const intervalCallback = useCallback(() => {
    const target = document.activeElement as HTMLInputElement | null

    if (target && value !== target.value) {
      setValue(target.value)
    }
  }, [value])

  useEffect(() => {
    interval.current = setInterval(intervalCallback, 100)

    return () => {
      clearInterval(interval.current)
    }
  }, [])

  if (!screen.shouldDisplay.inputMask || !0) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999,
      }}
    >
      <div
        style={{
          width: '200px',
          maxWidth: '90%',
          fontSize: '25px',
          padding: '10px',
          borderRadius: '5px',
          pointerEvents: 'none',
          background: '#FFF',
          boxShadow: '1px 1px 2px #FFF',
        }}
      >
        {value}
      </div>
    </div>
  )
}

export default withScreenInfo(InputMask)
